import { createLogicMiddleware } from 'redux-logic';
import { createLogger } from 'redux-logger';

import { rootReducer, rootLogic } from '../logic';
import { memberStorage } from 'utils';
import { dataLayer, httpClient } from 'utils';

export const ngReduxProvider = $ngReduxProvider => {
  'ngInject';

  const logic = createLogicMiddleware(rootLogic, {
    dataLayer,
    httpClient,
    memberStorage,
  });

  const middleware = ['ngUiRouterMiddleware', logic];
  const enhancers = [];

  // Add logger and devtools in development
  if (process.env.NODE_ENV === 'development') {
    const logger = createLogger({
      level: 'info',
      collapsed: true,
    });

    middleware.push(logger);

    const {
      devToolsEnhancer,
    } = require('redux-devtools-extension/developmentOnly');

    enhancers.push(devToolsEnhancer());
  }

  $ngReduxProvider.createStoreWith(rootReducer, middleware, enhancers);
};



// WEBPACK FOOTER //
// ./src/providers/ngReduxProvider.js